// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1zmjg","title":"Info_title__3xTk6","links":"Info_links__3qsji","link":"Info_link__36CKm","logo":"Info_logo__2gYh6"};